// Libs
import React, { Component } from 'react';
import { connect } from 'react-redux';

class AuthRequire extends Component {
  // static contextTypes = {
  //   router: React.PropTypes.object
  // }

  UNSAFE_componentWillMount() {
    this.verifyAuthenticated()
  }

  UNSAFE_componentWillUpdate(nextProps) {
    this.verifyAuthenticated()
  }

  verifyAuthenticated() {
    const { authenticated, user } = this.props
    const currentLocation = window.location.href

    if (!authenticated) {
      document.location.href = '/login'
    } else {
      if (currentLocation === '/') {
        if (user.role === 'lawyer') {
          document.location.href = '/meus-casos'
        } else if (user.role === 'company') {
          document.location.href = '/dashboard'
        }
      }
    }
  }

  render() {
    const { children, ...props } = this.props
    const ComposedComponent = React.cloneElement(children, { ...props })
    return ComposedComponent
  }
}

AuthRequire = connect(state => {
  return {
    authenticated: state.auth.authenticated,
    invited: state.auth.invited,
    firstTime: state.auth.firstTime,
    user: state.auth.user
  }
}, {})(AuthRequire)

export default AuthRequire